import { lazy, type ComponentType } from "react";

type Loader = () => Promise<{ default: ComponentType }>;

export type LazyPage = ComponentType & { preload: () => Promise<void> };

/** A route page split into its own chunk. Once `preload()` has resolved the page
 *  renders synchronously, which is what hydration and the prerenderer need: main.tsx
 *  preloads the current route before hydrateRoot, and scripts/prerender.tsx preloads
 *  every page before renderToString. Pages reached later by client-side navigation
 *  load on demand behind the Suspense boundary in Layout. */
export const lazyPage = (load: Loader): LazyPage => {
  let Loaded: ComponentType | null = null;
  const preload = () =>
    load().then((m) => {
      Loaded = m.default;
    });
  const Lazy = lazy(() => preload().then(() => ({ default: Loaded! })));
  const Page = (() => (Loaded ? <Loaded /> : <Lazy />)) as unknown as LazyPage;
  Page.preload = preload;
  return Page;
};
